import { ContactForm } from "components/ContactForm/ContactForm";

export const ContactPage = () => {
  return (
    <div>
      <ContactForm />
    </div>
  );
};
